import {
  IconBookmark,
  IconKey,
  SequenceMenu,
  SettingsFormControl,
  SettingsFormControlIcon,
  useModalState,
  useNotifications,
  SimpleModal,
  Box
} from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const ApiKeyCard = ({
  apiKey
}: {
  apiKey: {
    id: string
    name: string
    pinnedApiVersion?: string
  }
}) => {
  const { isModalOpen, openModal, closeModal } = useModalState()

  return (
    <>
      <SettingsFormControl
        key={apiKey.id}
        label={apiKey.name}
        htmlFor={`api-key-${apiKey.id}`}
        helper={
          <>
            {apiKey.id}
            {apiKey.pinnedApiVersion && (
              <>
                <IconBookmark
                  style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    margin: '0 4px'
                  }}
                />
                {apiKey.pinnedApiVersion}
              </>
            )}
          </>
        }
        icon={
          <SettingsFormControlIcon>
            <IconKey />
          </SettingsFormControlIcon>
        }
      >
        <SequenceMenu
          variant="ghost"
          buttonSize="medium"
          items={[
            {
              label: 'Delete API key',
              style: { color: 'red' },
              onClick: e => {
                e.stopPropagation()
                openModal()
              }
            }
          ]}
        />
      </SettingsFormControl>
      <DeleteApiKeyDialog
        id={apiKey.id}
        name={apiKey.name}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </>
  )
}

const DeleteApiKeyDialog = ({
  name,
  id,
  isOpen,
  onClose
}: {
  name: string
  id: string
  isOpen: boolean
  onClose: () => void
}) => {
  const { displayNotification } = useNotifications()

  const mutator = useMutation(dashboard20240730Client.deleteOAuthClient, {
    onSuccess() {
      displayNotification('API key deleted', {
        type: 'success'
      })
    },
    onError() {
      displayNotification('API key failed to delete ', {
        type: 'error'
      })
    }
  })

  return (
    <SimpleModal
      variant="dialog"
      data-testid="apiKeys.deleteDialog"
      isOpen={isOpen}
      onClose={onClose}
      title="Delete API key"
      submitButtonText="Delete"
      submittingButtonText="Deleting"
      isDestructive
      disableSubmitOnEnter
      onSubmit={async () => {
        try {
          await mutator.mutateAsync({ id })
        } catch {
          return false
        }
        return true
      }}
    >
      Are you sure? This will permanently delete the <b>{name}</b> API key.
    </SimpleModal>
  )
}
